import { gEnums } from "global/enums/globalEnums";
import { dataModificationTypes, itemActionTypes } from "global/viewSettings/enums/itemActionTypes";
import { useContext, useMemo } from "react";
import { FrameworkContext } from "../FrameworkContent";
import { ParentContext } from "../ParentContext";
import { useAppUserAccess } from "./useAppUserAccess";
import { _viewStatusTypes, useViewItemStatus } from "./useViewItemStatus";

export const useDataModifications = ({ isLongPress = false, uivi = null } = {}) => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states
  const { aps_global, aps_views } = _.get(currentSettings_state, 'gvviSettings', {});
  const appUserAccess = useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { fw_info } = framework_state ?? {}
  const { view, uivi: viewItemKey } = fw_info ?? {}

  const _uivi = uivi || viewItemKey

  const aps_view = aps_views?.[view]
  const { viewItems: viewItems_page } = aps_view ?? {}
  const viewItem = viewItems_page?.[_uivi]

  const viewItemStatus = useViewItemStatus({ uivi: _uivi })

  const { dataModifications: dataModifications_global } = aps_global ?? {}
  const { dataModifications: dataModifications_pageItem } = viewItem ?? {}

  // if (isAdminOrSuper) {
  //   _.forEach(dataModificationTypes, (dmt, dmtKey) => {
  //     dataModifications_global[dmtKey] = { accessLevel: appUserAccess.accessLevel, allowAction: true }
  //   })
  // }

  const { appUserAccessType, accessLevelTypes } = appUserAccess ?? {}

  const { viewStatusType } = viewItemStatus ?? {}

  const allowSolo = (dmk) => {
    switch (dmk) {
      case itemActionTypes.edit:
      case itemActionTypes.images:
      case itemActionTypes.notification:
      case itemActionTypes.pdfs:
      case itemActionTypes.rating:
      case itemActionTypes.requestAccess:
        // case itemActionTypes.status:
        return true
      default:
        return false
    }
  }

  const allowList = (dmk) => {
    switch (dmk) {
      case itemActionTypes.add:
      case itemActionTypes.sorting:
      case itemActionTypes.status:
        return true
      default:
        return false
    }
  }

  const allowSubList = (dmk) => {
    switch (dmk) {
      case itemActionTypes.add:
      case itemActionTypes.dataLinking:
      case itemActionTypes.filters:
      case itemActionTypes.status:
      case itemActionTypes.sorting:
        return true
      default:
        return false
    }
  }

  const { dmOpts, dms } = useMemo(() => {

    let _allowCombo;
    let _dms = {}

    switch (appUserAccessType) {
      case gEnums.appUserAccessTypes.appDataAdminLimited:
        if (accessLevelTypes && accessLevelTypes.includes(_uivi)) {
          _allowCombo = appUserAccess && appUserAccess.accessLevel >= gEnums.authLevels.appDataAdmin.value
        }
        break;
      default:
        _allowCombo = appUserAccess && appUserAccess.accessLevel >= gEnums.authLevels.appDataAdmin.value
    }

    if (_allowCombo) {
      if (dataModifications_global && dataModifications_pageItem) {
        _dms = { ...dataModifications_global, ...dataModifications_pageItem }
      } else if (dataModifications_global) {
        _dms = { ...dataModifications_global }
      }
    } else {
      _dms = dataModifications_pageItem ? { ...dataModifications_pageItem } : {}
    }

    const _dmOpts = {
      all: {},
      list: {},
      solo: {},
      subList: {},
      dmFor: {
        view: view,
        uivi: _uivi
      },
      viewItemStatus
    }

    _.forEach(_dms, (dm, dmk) => {
      switch (viewStatusType) {
        case _viewStatusTypes.solo:
          if (allowSolo(dmk)) {
            _dmOpts.solo[dmk] = dm
          }
          break;

        case _viewStatusTypes.list:
          if (allowList(dmk)) {
            _dmOpts.list[dmk] = dm
          }
          if (allowSolo(dmk)) {
            _dmOpts.solo[dmk] = dm
          }
          break;

        case _viewStatusTypes.subList:
          if (allowSubList(dmk)) {
            _dmOpts.subList[dmk] = dm
          }
          if (isLongPress && allowSolo(dmk)) {
            _dmOpts.solo[dmk] = dm
          }
      }
    })
    return { dmOpts: _dmOpts, dms: _dms }

  }, [appUserAccess, appUserAccessType, _uivi])

  // adjust for dataModifications at the page level where allowAction = false
  if (dataModifications_pageItem) {
    _.forEach(dataModifications_pageItem, (dm, key) => {
      if (!dm.allowAction) {
        delete dataModifications_pageItem[key]
      }
    })
  }

  if (isLongPress) {
    switch (viewStatusType) {
      case _viewStatusTypes.solo:
        return { _dataModificationOpts: dmOpts.solo, dmOpts }
      case _viewStatusTypes.list:
        return { _dataModificationOpts: dmOpts.list, dmOpts }
      case _viewStatusTypes.subList:
        return { _dataModificationOpts: dmOpts.subList, dmOpts }
      default:
        return { _dataModificationOpts: dms, dmOpts }
    }
  } else {
    return { _dataModificationOpts: dms, dmOpts }
  }
};